import { polyfills, isObjectFitSupported } from './polyfills/polyfills';
import 'what-input';
import './lib/a11y-toggle-2.1.0';
import { yall } from './vendor/yall-v3.1.6';
import { menu } from './modules/menu';
import { video } from './modules/video';
import closeDropdown from './modules/close-dropdown';
import toggleMobileMenu from './modules/toggle-mobile-menu';
import 'tabbyjs';
import Handorgel from 'handorgel';
import { cookieConsent } from './modules/cookie-consent';
import { init as googleMapsInit } from './modules/googlemaps';
import hourMinuteCounter from './modules/hourminutecounter';
import AOS from 'aos';

const start = () => {
  console.log('App loaded!!');

  if (!isObjectFitSupported) {
    const objectFitElements = document.querySelectorAll(
      '.js-object-fit:not(.lazy)',
    );

    if (objectFitElements) {
      objectFitPolyfill(objectFitElements);
    }
  }

  yall({
    events: {
      load: function (event) {
        const element = event.target;

        if (!element.classList.contains('lazy') && element.nodeName == 'IMG') {
          element.classList.add('lazy--loaded');

          if (
            !isObjectFitSupported &&
            element.classList.contains('js-object-fit')
          )
            objectFitPolyfill(element);
        }
      },
    },
    observeChanges: true,
  });

  const menuElement = document.getElementById('js-site-header');
  if (menuElement) {
    menu.init();
  }

  const tabsSelectors = document.querySelectorAll('[data-tabs]');
  for (const [i, tabsContainer] of [...tabsSelectors].entries()) {
    tabsContainer.setAttribute(`data-tabs-${i}`, '');
    const tabs = new Tabby(`[data-tabs-${i}]`);
  }

  const handorgels = document.querySelectorAll('[data-handorgel]');

  handorgels.forEach(elem => {
    new Handorgel(elem);
  });

  const videoSelector = '.js-c-video';
  video(videoSelector);
  toggleMobileMenu.init();
  closeDropdown.init();
  cookieConsent.init();
  googleMapsInit();
  hourMinuteCounter.init();

  AOS.init({
    once: true,
    duration: 600,
    offset: 400,
  });
};

export const app = () => {
  if (!polyfills) {
    start();
  } else {
    Promise.all([...polyfills])
      .then(_ => {
        try {
          start();
        } catch (error) {
          console.error('Failed to start the app', error);
        }
      })
      .catch(error => {
        console.error('Failed fetching polyfills', error);
      });
  }
};

// eslint-disable-next-line no-unused-expressions
document.readyState !== 'loading'
  ? app()
  : document.addEventListener('DOMContentLoaded', app);
